import React, { Component } from 'react'
import Select from 'react-select'
import './signupwix.css'
import { Alert, Button, Card, Input, Label } from 'reactstrap'
import { TagsInput } from 'react-tag-input-component'
import { validateEmail } from '../../utils/validations'
import * as url from '../../utils/url'
import axios from '../../axios'
import { formatPhoneNumber, Spinner } from '../../utils/constants'
import { CgList } from 'react-icons/cg'
import { MdOutlineMailOutline } from 'react-icons/md'
import { IoMdContact } from 'react-icons/io'
import { FaPhone } from 'react-icons/fa6'
import { GrOrganization } from 'react-icons/gr'
import { MdEventSeat } from 'react-icons/md'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { isMobile } from '../../utils/deviceInfo'
import trivvyLogo from '../../assets/trivvy/trivvy-logo-img.png'


const params = new URLSearchParams(window.location.search)

export default class Signup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      plantype:
        params.get('planType') == 'plus'
          ? '002'
          : params.get('planType') == 'premium'
          ? '003'
          : '001',
      email: '',
      organizationName: '',
      invitedUsers: [],
      validationErrors: [],
      loading: false,
      signupSuccess: false,
      apiErrorMessage: '',
      maxUserSeatsAllowed: 0,
      primaryName: '',
      phoneNumber: '',
      linkClicked: false,
      userLoginCreds: null,
    }
  }
  // publicEmailsCheck = (email) => {
  //   const publicEmails = [
  //     'gmail.com',
  //     'yahoo.com',
  //     'hotmail.com',
  //     'aol.com',
  //     'live.com',
  //     'outlook.com',
  //   ]

  //   for (const id of publicEmails) {
  //     if (email.indexOf(id) >= 0) {
  //       return false
  //     }
  //   }

  //   return true
  // }
  validate = () => {
    this.setState({
      validationErrors: [],
    })
    const {
      plantype,
      email,
      organizationName,
      invitedUsers,
      primaryName,
      phoneNumber,
      linkClicked,
    } = this.state
    const errors = []
    if (!email) {
      errors.push('Please enter email')
    } else {
      if (!validateEmail(email)) {
        errors.push('Please enter valid user email')
      } else {
        // if (!this.publicEmailsCheck(email)) {
        //   errors.push('Please enter valid domain email of your organization')
        // }
      }
    }
    if (!organizationName) {
      errors.push('Please enter organization name')
    }
    if (!plantype) {
      errors.push('Please select payment plan')
    }
    if (!primaryName) {
      errors.push('Please enter full name')
    }
    if (!phoneNumber) {
      errors.push('Please enter mobile number')
    }

    if (invitedUsers.length) {
      let flag = false
      for (const i of invitedUsers) {
        if (!validateEmail(i) || i.indexOf(email.split('@')[1]) < 0) {
          console.log(i)
          flag = true
        }
      }
      if (flag === true) {
        errors.push(
          `Please enter valid invite email of organization domain ${
            email.split('@')[1]
          }`
        )
      }
    }
    this.setState({
      validationErrors: errors,
    })

    if (errors.length) {
      return false
    } else {
      return true
    }
  }

  submitForm = () => {
    if (this.validate()) {
      this.setState({ loading: true })
      const {
        plantype,
        email,
        organizationName,
        invitedUsers,
        validationErrors,
        primaryName,
        phoneNumber,
      } = this.state
      const payload = {
        email: email.toLowerCase(),
        organizationName,
        planType: plantype,
        invitedUsers,
        primaryName,
        phoneNumber,
      }

      console.log(payload)

      axios
        .post(url.createTrivvyOrgAccountFromWebsiteWithPlan, payload)
        .then((data) => {
          this.setState({
            loading: false,
            signupSuccess: true,
            userLoginCreds: data.data.data.credentials,
          })
        })
        .catch((error) => {
          console.log(error)
          this.setState({ loading: false })
          this.setState({ signupSuccess: false })
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            this.setState({
              apiErrorMessage: error.response.data.errors.message,
            })
          }
        })
    } else {
    }
  }

  componentDidMount() {
    // const params = new URLSearchParams(window.location.search);

    const planType = params.get('planType')
    console.log('plan 177--- ', planType)

    let maxSeats = 0
    let type = ''

    if (planType == 'basic') {
      maxSeats = 0
      type = '001'
    }
    if (planType == 'plus') {
      maxSeats = 3
      type = '002'
    }
    if (planType == 'premium') {
      maxSeats = 5
      type = '003'
    }

    this.setState({ plantype: type, maxUserSeatsAllowed: maxSeats })
    console.log('type ')
  }
  render() {
    let {
      plantype,
      email,
      organizationName,
      invitedUsers,
      validationErrors,
      loading,
      signupSuccess,
      apiErrorMessage,
      maxUserSeatsAllowed,
      primaryName,
      phoneNumber,
      linkClicked,
      userLoginCreds,
    } = this.state
    const params = new URLSearchParams(window.location.search)
    console.log('plantype 214 ----', plantype)
    const withPlan = params.get('withPlan')
    const planTypeOptions = [
      {
        value: '001',
        label: 'Basic Plan (Free)',
      },
      // {
      //   value: '002',
      //   label: 'Plus Plan',
      // },
      // {
      //   value: '003',
      //   label: 'Premium Plan',
      // },
    ]

    return (
      <div id="externalSignupPaymentPlan" style={{ marginBottom: '100px' }}>
        <div className="my-3 d-flex align-items-center justify-content-center">
          {/* <img src={trivvyLogo} height="40" width="40" /> */}
          <span
            style={{ fontSize: '40px', marginLeft: '10px' }}
            className="sidebar-trivvy-logo-txt">
            Trivvy
          </span>
        </div>
        {loading ? (
          <div className="text-center">
            <h4>Please wait creating your Trivvy account</h4>
            <img src={Spinner} className="spinner-pos" />
          </div>
        ) : (
          <div>
            {signupSuccess == true ? (
              <Card
                className="mt-3 pb-4 pt-2 px-2 shadow"
                style={{ borderWidth: '0px', borderRadius: '8px' }}>
                <div className="text-center">
                  <h4 className="mt-3 mb-4">
                    Congratulations, {primaryName && primaryName.split(' ')[0]}!
                  </h4>

                  <div className="m-3">
                    <Alert className="mt-4 p-3 text-left" color="success">
                      <p>
                        You have successfully created your Trivvy account.
                        Please check <b> {email} </b> for the login information.
                      </p>
                      <p>
                        <b>Note - </b>If you do not receive an email within the
                        next few minutes, please check your spam folder. If not
                        there, please contact your IT department to check the
                        security settings and allow emails from{' '}
                        "{organizationName} via Trivvy" which have
                        "[Trivvy]" in the Subject line, or are from this IP address{' '}
                        {!linkClicked && (
                          <span
                            className="text-info cursor-pointer mr-1"
                            onClick={() => {
                              this.setState({ linkClicked: true })
                            }}>
                            (click here)
                          </span>
                        )}{' '}
                        {linkClicked && <b className="">159.183.195.40</b>}
                      </p>

                      {userLoginCreds && (
                        <p className="mt-2">
                          If you are having trouble locating the email, click
                          here to go to{' '}
                          <a
                            href="https://trivvy.ouroffice.io"
                            target="_blank"
                            rel="noopener noreferrer">
                            Trivvy
                          </a>{' '}
                          portal and enter the following credentials to log in.
                          You will be asked to pick a new password after logging
                          in.
                        </p>
                      )}

                      {userLoginCreds && (
                        <p className="ml-5">
                          {' '}
                          <div>
                            Email:{' '}
                            <b className="ml-2">{userLoginCreds.email}</b>{' '}
                          </div>{' '}
                          <div className="mt-2">
                            {' '}
                            Temporary password:{' '}
                            <b className="ml-2">
                              {userLoginCreds.temp_password}
                            </b>
                          </div>{' '}
                        </p>
                      )}
                    </Alert>
                  </div>
                  <img
                    src="/trivvy-people.png"
                    height="300px"
                    width="400px"
                    style={{
                      height: '250px',
                      width: isMobile ? '90%' : '450px',
                    }}
                    className="mt-4"
                    alt=""
                  />
                </div>
              </Card>
            ) : signupSuccess == false ? (
              <div className={!isMobile ? 'mx-5' : ''}>
                <div className="mt-5 ext-register-container">
                  <h4 className="text-center">Create Account</h4>
                  <div className="my-2 ext-trivvy-signup-form-rows">
                    <Label>
                      {' '}
                      <CgList size={15} className="mr-1" /> Plan Type
                    </Label>

                    {/* <ul className="ext-register-list-plan-details">
                       <li> Basic plan type</li>
                        <li>
                        price: Free
                        </li>
                        <li>
                          responses: 100
                          </li>
                        <li>
                          seats: 1
                          </li>
                       <li>
                        Performance Metrics provided by Trivvy
                        </li>
                        <li>
                          Reward feature: not provided
                          </li>
                    </ul> */}
                    <Select
                      placeholder="Select plan..."
                      value={
                        planTypeOptions.find(
                          (opt) => opt.value === this.state.plantype
                        ) || null
                      }
                      onChange={(v) => {
                        if (v) {
                          this.setState({ plantype: v.value })
                          let maxSeats = 0
                          if (v.value == '002') {
                            maxSeats = 3
                          }
                          if (v.value == '003') {
                            maxSeats = 5
                          }
                          this.setState({ maxUserSeatsAllowed: maxSeats })
                        }
                      }}
                      options={planTypeOptions}
                    />
                  </div>
                  <div className="my-2 ext-trivvy-signup-form-rows">
                    <Label>
                      <IoMdContact size={15} className="mr-1" />
                      Full Name{' '}
                    </Label>
                    <Input
                      type="email"
                      placeholder="Enter name"
                      value={primaryName}
                      onChange={(e) =>
                        this.setState({
                          primaryName: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="my-2 ext-trivvy-signup-form-rows">
                    <Label>
                      {' '}
                      <MdOutlineMailOutline size={15} className="mr-1" />
                      Business Email (1 seat)
                    </Label>
                    <Input
                      type="email"
                      placeholder="Enter your business email"
                      value={email}
                      onChange={(e) =>
                        this.setState({
                          email: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="my-2 ext-trivvy-signup-form-rows">
                    <Label>
                      {' '}
                      <FaPhone size={15} className="mr-1" />
                      Mobile Number
                    </Label>
                    {/* <Input
                    type="email"
                    placeholder="Enter email"
                    value={phoneNumber}
                    onChange={(e) =>
                      this.setState({
                        phoneNumber: e.target.value,
                      })
                    }
                  /> */}
                    <PhoneInput
                      placeholder="Enter mobile number"
                      value={phoneNumber}
                      onChange={(v) => {
                        this.setState({
                          phoneNumber: formatPhoneNumber(v),
                        })
                      }}
                      className="form-control p-0 pl-2"
                      defaultCountry="US"
                    />
                  </div>
                  <div className="my-2 ext-trivvy-signup-form-rows">
                    <Label>
                      <GrOrganization size={15} className="mr-1" />
                      Organization Name{' '}
                    </Label>
                    <Input
                      placeholder="Enter company name"
                      value={organizationName}
                      onChange={(e) =>
                        this.setState({
                          organizationName: e.target.value,
                        })
                      }
                    />
                  </div>
                  {plantype != '001' && maxUserSeatsAllowed > 0 ? (
                    <div className="my-3 ext-signup-user-seats">
                      <Label>
                        {' '}
                        <MdEventSeat size={15} className="mr-1" />
                        Additional User Seats (up to {maxUserSeatsAllowed - 1} allowed)
                      </Label>
                      <div className="ext-signup-user-seats-emails">
                        {' '}
                        emails should be comma separated <b>(Optional)</b>
                      </div>
                      <TagsInput
                        separators={[',', 'Enter']}
                        value={invitedUsers}
                        onChange={(value) => {
                          if (value.length > maxUserSeatsAllowed) {
                          } else {
                            this.setState({ invitedUsers: value })
                          }
                        }}
                        beforeAddValidate={(tag, existing) => {
                          if (existing.length >= maxUserSeatsAllowed) {
                            return false
                          } else {
                            return validateEmail(tag)
                          }
                        }}
                        placeHolder="Enter user emails or add later"
                      />

                      {/* <small>
                        Maximum {maxUserSeatsAllowed} emails allowed
                      </small> */}
                    </div>
                  ) : (
                    ''
                  )}

                  {validationErrors && validationErrors.length > 0 ? (
                    <Alert color="danger" className="my-2">
                      <div className="ext-signup-validation-ul">
                        {validationErrors.map((x) => (
                          <div>{x}</div>
                        ))}
                      </div>
                    </Alert>
                  ) : null}

                  {apiErrorMessage && (
                    <Alert className="my-2" color="danger">
                      {apiErrorMessage}
                    </Alert>
                  )}

                  <div className="mt-5 text-center">
                    <Button
                      onClick={this.submitForm}
                      className="trivia-action-button-main">
                      Submit
                    </Button>
                  </div>

                  <p className="text-center mt-3" style={{ fontSize: '12px', color: '#6c757d' }}>
                    By continuing, you agree to our{' '}
                    <a href="https://www.gotrivvy.com/terms-conditions" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>Terms of Use</a>
                    {' '}and{' '}
                    <a href="https://www.gotrivvy.com/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>Privacy Policy</a>.
                  </p>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        )}
      </div>
    )
  }
}
